// Constants extracted from CoachMarksModule.js

import React from "react";

// Constants
export const NAME = "coachMarks";
export const UPDATE_DATA = "UPDATE_DATA" + " " + NAME;
export const UPDATE_COACHMARK_STATUS = "UPDATE_COACHMARK_STATUS" + " " + NAME;
